import React from 'react'
import iconNames from 'theme/icons'
import * as priceListActions from 'actions/priceLists'
import { features } from 'helpers/constants'
import {t} from "helpers/language"

export const skill = {
  key: "ADD_PART",
  group: 'pricelists',
  label: t("Add a part"),
  desc: t("Add a new part into your price list"),
  location: '/price-lists/manage-price-lists',
  feature: features.PRICE_LISTS_LICENCE,
  steps: [
    {
      title: "Price Lists",
      titleIcon: iconNames.priceList,
      content: (
        <div>
          Create and store items you buy and sell inside price lists.<br/>
          <br/>
          Add material, labour and nested assemblies, then set the sales price using a variety of options including
          customer pricing and multiple price breaks to make sure you optimise margins and profits.<br/>
          <br/>
          To get started, you can <b>import your price list</b> from a CSV file, or
          learn how to <b>add a new part</b><br/>
        </div>
      ),
      actions: [
        {
          label: "Import My Price List",
          type: "nav",
          location: '/price-lists/import',
        },
        {
          label: "Add a Part",
          primary: true,
          type: "next",
        },
      ],
    },
    {
      target: '.treeView-nodes-expanded',
      content: <div>To add a new part, first we need to select which price list to add it to. <i>Select a price list</i> from the list.</div>,
      action: () => priceListActions.selectAllPriceLists(),
    },
    {
      target: '.pivotTable-header-addButton',
      content: <div>Now we can add our new part, click <i>NEW PART</i> to begin.</div>,
    },
    {
      // Inline tooltip in add part dialog
      dummy: true,
    },
    {
      title: "Part Added",
      titleIcon: iconNames.tick,
      titleIconColor: "green",
      content: (
        <div>
          {"Brilliant, you've added a part to your price list"}<br/>
          <br/>
          {"Continue to learn more about complex pricing for more advanced options"}
        </div>
      ),
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: "Learn About Complex Pricing",
          primary: true,
          type: "skill",
          skill: "PART_PRICING",
          page: 1,
        },
      ],
    },
  ],
}

export default skill
